import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-white py-20 px-4 border-b border-gray-200" data-id="element-25">
      <div className="max-w-3xl mx-auto text-center" data-id="element-26">
        <ShieldCheck className="w-20 h-20 text-[#D4A843] mx-auto mb-6" data-id="element-27" />
        <h2 className="text-3xl md:text-4xl font-extrabold text-[#0B1A2E] mb-8" data-id="element-28">
          Garantía Total de 7 Días
        </h2>

        <div className="bg-gray-50 p-8 rounded-2xl border border-gray-100 text-lg md:text-xl text-gray-700 leading-relaxed space-y-6" data-id="element-29">
          <p data-id="element-30">
            Si en los próximos 7 días después de tu compra sentís que el Método
            A.C.C.I.Ó.N. no es lo que esperabas, te devolvemos el 100% de tu
            dinero sin preguntas y sin vueltas.
          </p>
          <p data-id="element-31">Sin formularios complicados. Sin explicaciones. Sin demoras.</p>
          <p className="font-bold text-[#0B1A2E]" data-id="element-32">
            Así de seguro estamos de que esto va a cambiar tu forma de trabajar.
          </p>
        </div>
      </div>
    </section>;
}